// Called by : index.html (vue)

<template>
  <div id="page" class="" :class="getClass()">
    
    {{ forceUpdate }}

    <div v-if="qstPreload.length" id="qst_preload" class="d-none">
      <link v-for="qprld in qstPreload" :key="qprld.index" rel="preload" :as="qprld.as" :href="qprld.url">
    </div>

    <header id="header" class="header clearfix w-100 bg-transparent py-2 py-md-4" :class="getStyle()">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-dark bg-transparent m-0 px-0 py-2 py-md-0">

          <div class="navbar-brand text-left header_logos header_logo_left m-0"> 
            <img class="informat_logo ui_tip" :src="constants.assets.logoInformatPngFile" alt="InFormat" title="InFormat" width="" height="">
          </div>

          <button class="btn_navbar btn btn-outline-light px-3 py-2 mt-2 font-weight-bold d-inline d-lg-none" type="button" data-toggle="collapse" data-target="#app_navbar" aria-controls="app_navbar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="oi oi-menu"></span>
          </button>

          <div class="navbar-brand text-right header_logos header_logo_right m-0 d-inline d-lg-none"> 
            <img class="client_logo ui_tip" :src="constants.assets.logoCpfPngFile" alt="byCPF" title="byCPF" width="" height="">
          </div>

          <div class="collapse navbar-collapse mt-lg-3" id="app_navbar">
            <ul class="navbar-nav justify-content-sm-around w-100">

              <li class="nav-item my-2 my-lg-0" v-if="!isQuestion && !isPatience">
                <select-locale></select-locale>
              </li>

              <li class="nav-item my-2 my-lg-0" v-if="isConnect">
                <button-about></button-about>
              </li>

              <li class="nav-item my-2 my-lg-0" v-if="isAssignments">
                <select-infos></select-infos>
              </li>

              <li class="nav-item my-2 my-lg-0" v-if="isAssignments">
                <select-user></select-user>
              </li>

              <li id="btn_go_back" class="nav-item my-2 my-lg-0" v-if="(isQuestion || isPatience) && isGoBack">
                <button-go-back></button-go-back>
              </li>
              
            </ul>
          </div> <!-- .collapse -->

          <div class="navbar-brand text-right header_logos header_logo_right m-0 d-none d-lg-inline">
            <img class="client_logo ui_tip" :src="constants.assets.logoCpfPngFile" alt="byCPF" title="byCPF" width="" height="">
          </div>

        </nav>
      </div>
    </header>

    <main id="main" class="mb-4 py-4 " :class="getClass()">
      <div class="container">

        <router-view></router-view>

      </div>
    </main>

    <footer id="footer" class="footer clearfix p-2 " :class="getClassFooter()">
      <p class="text-center m-0">
        <span v-if="isQuestion || isPatience" class="footer_link">
          {{ constants.project.name }}&nbsp;|&nbsp;{{ constants.project.owner }}&nbsp;|&nbsp;{{ constants.project.copyright }}
        </span>
        <a v-if="!isQuestion && !isPatience" v-bind:href="constants.project.webLink" class="footer_link" target="_blank">
          {{ constants.project.name }}&nbsp;|&nbsp;{{ constants.project.owner }}&nbsp;|&nbsp;{{ constants.project.copyright }}
        </a>
      </p>
    </footer>

    <modal-cgu v-if="isAssignments"></modal-cgu>
    <modal-apr v-if="isApr && isAssignments"></modal-apr>
    <modal-sign v-if="isSign && isAssignments"></modal-sign>
    <modal-about v-if="!isQuestion && !isPatience"></modal-about>

    <button id="btn_pge_cgu" class="d-none" data-toggle="modal" data-target="#pge_cgu"><!-- {{ $t('infos.cgu') }} --></button>
    <button id="btn_pge_apr" class="d-none" data-toggle="modal" data-target="#pge_apr"><!-- {{ user.fullName }} --></button>
    <button id="btn_pge_sign" class="d-none" data-toggle="modal" data-target="#pge_sign"><!-- {{ user.fullName }} --></button>

    {{ forceRefresh }}

  </div> <!-- #page -->
</template>

<script>
//       <img v-for="qprld in qstPreload" :key="qprld.index" :src="qprld" alt="" class="d-none">

import { constants } from '@/constants'
import SelectLocale from '@/components/header/SelectLocale'
import SelectInfos from '@/components/header/SelectInfos'
import SelectUser from '@/components/header/SelectUser'
import ButtonLogout from '@/components/header/ButtonLogout'
import ButtonAbout from '@/components/header/ButtonAbout'
import ButtonGoBack from '@/components/header/ButtonGoBack'
import ModalCgu from '@/components/misc/ModalCgu'
import ModalAbout from '@/components/misc/ModalAbout'
import ModalInfo from '@/components/misc/ModalInfo'
import ModalSign from '@/components/misc/ModalSign'
import ModalApr from '@/components/misc/ModalApr'

export default {
  name: 'app',
  components: {
    SelectLocale,
    SelectInfos,
    SelectUser,
    ButtonLogout,
    ButtonAbout,
    ButtonGoBack,
    ModalCgu,
    ModalAbout,
    ModalInfo,
    ModalSign,
    ModalApr,
  }, 
  data() {
    return {
      isConnect: false,
      isNoConnect: true,
      isAssignments: false,
      isQuestion: false,
      isPatience: false,
      isGoBack: false,
      isApr: false,
      isSign: false,
      dateYear: f_getDateYear_s(true),
      qstPreload: [],
    }
  },
  methods: {
    getShow() {
      return { 'd-none': this.isGoBack }
    },
    getClass() {
      return { 'bg-white': this.isNoConnect }
    },
    getStyle() {
      if (this.isNoConnect) {
        $('body.body_home').addClass('no_image')
      } else {
        $('body.body_home').removeClass('no_image')
      }
      return { 'no_image': this.isConnect }
    },
    getClassFooter() {
      return { 'text-white': this.isConnect }
    },
    setDatas() {
      this.isConnect = this.$route.name == 'connect';
      this.isNoConnect = this.$route.name != 'connect';
      this.isAssignments = this.$route.name == 'assignments';
      this.isQuestion = this.$route.name == 'question';
      this.isPatience = this.$route.name == 'patience';
      this.isGoBack = !Boolean(this.lesson.isNoStopLec);
      this.qstPreload = this.questionsPreload;
      this.isSign = this.params.isSignature;
      this.isApr = this.params.isAprEditDatas;
    },
  },
  updated: function() {
    return '';
  },
  computed: {
    constants() {
      return constants
    },
    params() {
      return this.$store.state.params
    },  
    user() {
      return this.$store.state.user
    },
    lesson() {
      return this.$store.state.lesson
    },  
    questionsPreload() {
      return this.$store.state.questionsPreload
    },  
    forceUpdate() {
      this.setDatas();
      return '';
    },
    forceRefresh() {
      return '';
    },
  },
}
</script>

<style scoped>

/* Le bouton d'effacement du champ de recherche */
#erase_filter {
  top: -2px;
  right: 4px;
  outline: none;
  display: none;
}

/* Les logos InFormat et Client (CPF pour le moment) */
.navbar .header_logos {
    width: 100%;
    height: 100%;
    max-width: 240px;
    max-height: 120px;
    min-width: 120px;
    min-height: 80px;
    position: relative;
}
.navbar .header_logos.header_logo_left {
    width: 240px;
    max-width: 240px;
    min-width: 160px;
    /* margin-right: 10px; */
}
.navbar .header_logos.header_logo_right {
    width: 160px;
    max-width: 160px;
    min-width: 80px;
    /* margin-left: 10px; */
}
.navbar .informat_logo,
.navbar .client_logo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    object-fit: contain;
}

/* Les informations du pied de page */
#footer.footer {
    font-size: 0.75em;
    font-weight: 300;
    background-color: transparent; /* #e9ecef */
    position: absolute;
    bottom: 0px;
    min-width: 100%;
    color: #999;
    letter-spacing: 2px;
}
#footer .footer_link {
  color: #999 !important;
  text-decoration: none !important;
}
#footer.text-white .footer_link {
  color: #fff !important;
}
#footer .footer_link:hover {
  text-decoration: none !important;
}

/* Ordre des modales */
#pge_cgu {
  z-index: 2040;
}
#pge_apr {
  z-index: 2020;
}
#pge_sign {
  z-index: 2000;
}

/*----------------------------------------*\
//* Responsive
\*----------------------------------------*/

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) { 
  .navbar .header_logos.header_logo_left {
      max-width: 200px;
      min-width: 200px;
      min-height: 80px;
  }
  .navbar .header_logos.header_logo_right {
      max-width: 140px;
      min-width: 140px;
      min-height: 80px;
  }
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) { 
  .navbar .header_logos.header_logo_left {
      max-width: 160px;
      min-width: 160px;
      min-height: 60px;
  }
  .navbar .header_logos.header_logo_right {
      max-width: 100px;
      min-width: 100px;
      min-height: 60px;
  }
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) { 
  .navbar .header_logos.header_logo_left {
      max-width: 120px;
      min-width: 120px;
      min-height: 45px;
  }
  .navbar .header_logos.header_logo_right {
      max-width: 70px;
      min-width: 70px;
      min-height: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue